module.exports = __webpack_public_path__ + "static/media/TT.86a93444.png";